import { useQuery } from '@tanstack/react-query'

import { getMonthlyUserCardSummaries } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMonthlyUserCardSummaries = (
  organizationId: string,
  yearMonth: string
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!organizationId,
    queryFn: () =>
      getMonthlyUserCardSummaries(axiosInstance, organizationId, yearMonth),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_MONTHLY_USER_CARD_SUMMARIES],
  })

  return { data, isError, isLoading }
}
